// extracted by mini-css-extract-plugin
module.exports = {"dataImageGenerator":"styles_dataImageGenerator__2nsz5","header":"styles_header__3Dgqm","container":"styles_container__39OL_"};